<div class="card">
    <div class='row'>
        <div class='column'>
          <div>
            {{ titleGraph }}
          </div>
        </div>
        <div class='column'>
          <div class='menu-column' [hidden]="!showMenuOption">
            <button (click)="selectOptionMenu(weekly.id)" id="weekly" value="weekly" class="btn-menu selected" #weekly>Semanal</button>
            <button (click)="selectOptionMenu(monthly.id)" id="monthly" value="monthly" class="btn-menu" #monthly>Mensual</button>
            <button (click)="selectOptionMenu(yearly.id)" id="yearly" value="yearly" class="btn-menu" #yearly>Anual</button>
          </div>
        </div>
      </div>
    <p-chart #chart type="bar" [data]="dataGraph" [options]="optionsGraph" height="351px"></p-chart>
</div>